import { cn } from '@src/utils'
import './Badge.scss'

export const Badge = ({ className, children }) => {
  return <div className={cn('root-badge', className)}>
    <span>{children}</span>
  </div>
}
